var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".add-a{fill:#191818;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-a",
    d: "M-7630.341,11.317c0-.006,0-.013,0-.019l-.339,0c-2.035-.02-3.99.007-6.1.171l-.217-3.9c2.342.033,4.409.1,6.659.1.006-2.25-.063-4.316-.1-6.659l3.9.217c-.165,2.115-.191,4.069-.171,6.1q0,.172,0,.336h.021c2.259.007,4.331-.064,6.681-.1l-.217,3.9c-2.112-.164-4.067-.191-6.105-.171l-.379,0c0,.124,0,.251,0,.381-.021,2.036.006,3.99.171,6.1l-3.9.217C-7630.4,15.65-7630.335,13.577-7630.341,11.317Z",
    transform: "translate(7637 -0.999)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.bf45c7dcb0b17cc8207014a7e023b43e.svg";
export { ForwardRef as ReactComponent };